import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputItem from './input-item';

export const CusWeightForm = ({
  name,
  requiredTitle = 'Vui lòng nhập thông tin',
  value,
  label = '',
  onChange,
  error = false,
  helperText = '',
  isAddRow = true,
  disabledField = false,
  isShowPriceReal = true,
  unitList = [],
  isShowAction = true,
}) => {
  const initialValue = {
    weightandVolume: 0,
    price: 0,
    requestPrice: 0,
    unitCode: '',
    extraCost: 0,
    extraQuantity: 0,
  };
  const [values, setValues] = React.useState([initialValue]);
  const initRef = React.useRef(true);

  const onAdd = () => {
    setValues((prev) => {
      let tmp = [...prev];
      tmp.push({
        weightandVolume: 0,
        price: 0,
        requestPrice: 0,
        unitCode: '',
        extraCost: 0,
        extraQuantity: 0,
      });
      return tmp;
    });
  };
  const onDelete = (index) => {
    if (values && values.length === 1) {
      setValues([initialValue]);
    } else {
      setValues((prev) => {
        prev.splice(index, 1);
        return [...prev];
      });
    }
  };

  React.useEffect(() => {
    if (initRef.current && value?.length) {
      setValues(value);
      initRef.current = false;
    }
  }, [value]);
  React.useEffect(() => {
    onChange &&
      onChange({
        persist: () => {},
        target: {
          type: 'change',
          name,
          value: values,
        },
      });
  }, [values]);

  const renderItems = (item, index) => {
    return (
      <InputItem
        key={'price board custom LCL-' + index}
        item={item}
        index={index}
        onAdd={onAdd}
        onDelete={onDelete}
        values={values}
        setValues={setValues}
        error={error}
        isAddRow={isAddRow}
        disabledField={disabledField}
        isShowPriceReal={isShowPriceReal}
        unitList={unitList}
        isShowAction={isShowAction}
      />
    );
  };
  return (
    <FormGroup margin="dense">
      <FormLabel>{label}</FormLabel>
      {values.map((item, index) => renderItems(item, index))}
      <FormHelperText error={error}>{helperText && requiredTitle}</FormHelperText>
    </FormGroup>
  );
};
